import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { Breadcrumb, NavLinkButton } from '@shared/components/bootstrap';

import { PageHeader } from '@admin/components/helpers/page_header';
import { Panel } from '@admin/components/helpers/panel';
import { List as ContentPanel } from '@admin/components/landing/location/content/list';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { LandingLocationRouteQuery, useLandingLocationRouteQuery } from '@admin/schema';

const Content: React.FC<{
  route: LandingLocationRouteQuery['route'];
}> = ({ route }) => (
  <>
    <Panel>
      <Panel.Body>
        <div>
          Slug: <strong>{route.slug}</strong>
        </div>
        <div>
          Origin: <strong>{route.origin.name}</strong>
        </div>
        <div>
          Destination: <strong>{route.destination.name}</strong>
        </div>
        <div>
          Featured: <strong>{route.featured ? '✅' : '❌'}</strong>
        </div>
      </Panel.Body>
      <Panel.Footer align="right">
        <NavLinkButton kind="primary" to={`/landing/location/routes/${route.id}/edit`}>
          Edit
        </NavLinkButton>
      </Panel.Footer>
    </Panel>
    <ContentPanel location={route} />
  </>
);

export const Details: React.FC = () => {
  useTitle('Landing - Location - Routes - Details');
  const { id } = useParams<{ id: string }>();
  const { data } = useLandingLocationRouteQuery({
    client,
    fetchPolicy: 'cache-and-network',
    variables: { id },
  });
  const route = data?.route;

  return (
    <>
      <PageHeader>
        <Breadcrumb>
          <Breadcrumb.Item>Landing</Breadcrumb.Item>
          <Breadcrumb.Item>Location</Breadcrumb.Item>
          <Breadcrumb.Item>
            <NavLink to="/landing/location/routes">Routes</NavLink>
          </Breadcrumb.Item>
          {id && <Breadcrumb.Item active>{route?.id ?? '-'}</Breadcrumb.Item>}
        </Breadcrumb>
      </PageHeader>
      {route ? <Content route={route} /> : <Spinner />}
    </>
  );
};
